import React, { memo } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import LazyLoad from "react-lazyload";
import "./styles.scss";

const SearchBar = ({
  handleSearch = () => {},
  value = "",
  handleKeyPress = () => {},
  handleClick = () => {},
  backgroundColor = "",
  handleSubmit = () => {},
}) => {
  return (
    <InputGroup className="searchbar-styles">
      <InputGroup.Text
        id="basic-addon1"
        style={{
          color: "#8B97A8",
          background: backgroundColor ? backgroundColor : "#F1F3FA7",
          borderRightColor: backgroundColor ? "" : "#F1F3FA7",
        }}
      >
        <LazyLoad height={20} offset={100}>
          <img
            src="/MagnifyingGlass.svg"
            alt="search-icon"
            onClick={handleClick}
          />
        </LazyLoad>
      </InputGroup.Text>
      <Form.Control
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        className={backgroundColor ? "no-border" : ""}
        value={value}
        onChange={handleSearch}
        onSubmit={handleSubmit}
        onKeyDown={handleKeyPress} // Handle the keypress event
        style={{
          color: "#8B97A8",
          background: backgroundColor ? backgroundColor : "#F1F3FA7",
          borderLeftColor: backgroundColor ? "" : "#F1F3FA7",
        }}
      />
    </InputGroup>
  );
};

export default memo(SearchBar);
